const Wrapper = ({ Component, children }) => {
  return <Component>{children}</Component>;
};

export default Wrapper;
